// A notification (and a maintenance task) belongs to a machine, or to an
// equipment pool / area for pool- and area-level maintenance tasks.
export const OWNER_TYPES = ["equipment", "equipmentpool", "area"];

const findOwner = (wrappers) => {
  for (const wrapper of wrappers || []) {
    for (const type of OWNER_TYPES) {
      if (wrapper?.[type]) return { type, owner: wrapper[type] };
    }
  }
  return { type: null, owner: undefined };
};

/** Owner of a notification object (the `notification` itself, not its wrapper). */
export const getNotificationOwner = (notification) =>
  findOwner(notification?.isnotificationof);

/** Owner of a `/notifications/equipments` (or export) row: { equipment | equipmentpool | area }. */
export const getRowOwner = (row) => findOwner([row]);

export const isMachineOwner = (ownerInfo) => ownerInfo?.type === "equipment";

/** Where a click on the owner's name should go. */
export const getOwnerLink = ({ type, owner } = {}) => {
  if (type === "equipment" && owner?.nodeid) {
    return "/machine-overview?nodeid=" + encodeURIComponent(owner.nodeid);
  }
  if (type === "equipmentpool") return "/machines";
  if (type === "area") return "/sites";
  return null;
};

/** Pools and areas the user is subscribed to, for the notifications request. */
export const getSubscribedOwnerNodeIds = (subscribedEquipmentpools, subscribedSites) => {
  const equipmentpoolnodeids = Object.values(subscribedEquipmentpools || {})
    .map((pool) => pool?.nodeid)
    .filter(Boolean);
  const areanodeids = [
    ...new Set(
      Object.values(subscribedSites || {})
        .flatMap((site) => site?.hasarea || [])
        .map((entry) => entry?.area?.nodeid)
        .filter(Boolean),
    ),
  ];
  return { equipmentpoolnodeids, areanodeids };
};
